import { UIPAGE } from "@/constants/ui-page.constants";
import { RouteInfo } from "../types";
import { authGuard, permissionGuard } from "../guards";

const ViewCustomerProductUsageData = () =>
	import(/* webpackChunkName: "chunk-customer-product-usage-data" */ "@/views/customer/product-usage-data/CustomerProductUsageData.vue");

export const CustomerProductUsageDataRoute: RouteInfo = {
	id: UIPAGE.CUSTOMER_PRODUCT_USAGE_DATA,
	path: "/customers/:customerId/products/:productId/usage-data",
	component: ViewCustomerProductUsageData,
	guards: [authGuard, permissionGuard],
	props: (route) => ({
		customerId: route.query.customerId,
		productId: route.query.productId
	}),
	title: "customers.products.usageData.display"
};
